
import React from 'react';

const SiteOfficeFooter = () => {
  return (
    <div className="text-center mt-8 text-slate-600">
      <p className="text-sm opacity-80">
        © 2024 Progress Compass - Project Management System
      </p>
    </div>
  );
};

export default SiteOfficeFooter;
